import React, { MouseEvent } from 'react';

interface SqftIconProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
}

const SqftIcon = ({ className, onClick }: SqftIconProps) => {
  return (
    <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
      <path d="M0.476135 12H1.80947V10.6667H0.476135V12ZM3.1428 12H4.47614V10.6667H3.1428V12ZM1.80947 2.66667H0.476135V4H1.80947V2.66667ZM0.476135 9.33333H1.80947V8H0.476135V9.33333ZM4.47614 0H3.1428V1.33333H4.47614V0ZM1.80947 0H0.476135V1.33333H1.80947V0ZM9.80947 0H8.47614V1.33333H9.80947V0ZM11.1428 4H12.4761V2.66667H11.1428V4ZM11.1428 0V1.33333H12.4761V0H11.1428ZM8.47614 12H9.80947V10.6667H8.47614V12ZM7.1428 0H5.80947V5.33333H0.476135V6.66667H5.80947V12H7.1428V6.66667H12.4761V5.33333H7.1428V0ZM11.1428 12H12.4761V10.6667H11.1428V12ZM11.1428 9.33333H12.4761V8H11.1428V9.33333Z" fill="#191B1E"/>
    </svg>
  );
};

export default SqftIcon;